// extracted by mini-css-extract-plugin
export default {"modalContainer":"styles_modalContainer__JlB5W","subtitle":"styles_subtitle__zjlsV","btnContainer":"styles_btnContainer__BeVHI"};